/**
 * TypingIndicator Component
 * Pallini animati per indicare che il contatto sta scrivendo
 * Supporta animazione di uscita con fade out
 */

import { memo } from 'react';

interface TypingIndicatorProps {
  isVisible?: boolean;
}

export const TypingIndicator = memo(function TypingIndicator({ isVisible = true }: TypingIndicatorProps) {
  return (
    <div
      className={`flex items-end gap-1 mr-auto mt-3 mb-1 transition-all duration-300 ease-out origin-left
        ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
    >
      <div className="rounded-xl px-3 py-2 shadow-sm bg-white dark:bg-gray-800">
        <div className="flex gap-0.5 items-center">
          {/* GPU-accelerated animation con transform invece di bounce */}
          <div className="w-1.5 h-1.5 bg-[#787774] rounded-full typing-dot" style={{ animationDelay: '0ms' }} />
          <div className="w-1.5 h-1.5 bg-[#787774] rounded-full typing-dot" style={{ animationDelay: '150ms' }} />
          <div className="w-1.5 h-1.5 bg-[#787774] rounded-full typing-dot" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
});
